module.exports = __webpack_public_path__ + "img/d8.36983450.svg";